<div class="discoveryProcessContainer" >
    <div class="discoveryChat_container" >
        <div class="discoveryChat_header"></div>
        <div class="discoveryChat_body" #chatBody>
            <!-- <h2>{{'discoveryProcess.hello' | translate }} {{user?.firstName}}</h2> -->
            <app-chat-roll [chatMsgs]="answeredQuestionList" (selectDifferentAnswerEvent)="selectDiffernetAnswer()"></app-chat-roll>
            <app-chat-current-question 
            [focusBottom] = focusBottom
            [isLoading] = isLoading
            [currentQuestion]="questionList ? questionList[currentQuestionPos]: undefined" [consultant]="consultant" [removeResponses]="prevQuestionSetResponseToRemove" (sendQuestionResponseEvent)=setQuestionResponse($event)></app-chat-current-question>
        </div>
    </div>
    <div class="discoveryChat_footer">
        <app-progress-bar
            class="discoveryProcess_progessBar"
            [value]="progressBarValue"
            [showBackdrop]="false"
            [compact]="true"
        ></app-progress-bar>
    </div>
</div>